import { render, staticRenderFns } from "./SentenceSpeaking.vue?vue&type=template&id=47898d8c&scoped=true&"
import script from "./SentenceSpeaking.vue?vue&type=script&lang=js&"
export * from "./SentenceSpeaking.vue?vue&type=script&lang=js&"
import style0 from "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css?vue&type=style&index=0&lang=css&"
import style1 from "./SentenceSpeaking.vue?vue&type=style&index=1&id=47898d8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47898d8c",
  null
  
)

export default component.exports